import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {useNavigate, useLocation} from 'react-router-dom';
import {fetchCurrentAndPreviousLineItem} from '../../redux/actionCreators/station';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const mapDispatchToProps = dispatch => ({
	fetchCurrentAndPreviousLineItem: (navigate, successCallback, currentPath) =>
		dispatch(fetchCurrentAndPreviousLineItem(navigate, successCallback, currentPath)),
});

export const RedirectToLineItemState = ({
	fetchCurrentAndPreviousLineItem,
	children,
}) => {
	const navigate = useNavigate();
	const location = useLocation();
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		// Add a small delay to allow any pending navigation to complete
		const timer = setTimeout(() => {
			fetchCurrentAndPreviousLineItem(navigate, () =>
				setTimeout(() => {
					setLoading(false);
				}, 100),
				location.pathname
			);
		}, 200);

		return () => clearTimeout(timer);
	}, []);

	if (loading) return <LoadingSpinner variant="overlay" text="Loading..." />;

	return <>{children}</>;
};

RedirectToLineItemState.propTypes = {
	updateCurrentLineItem: PropTypes.func,
	updateLastLineItem: PropTypes.func,
	children: PropTypes.any,
};

export default connect(null, mapDispatchToProps)(RedirectToLineItemState);
